import React from 'react';
import { motion } from 'framer-motion';
import { T as TRANSITION_DURATION_IN_SECONDS, d as TRANSITION_DELAY_IN_SECONDS } from './DataList.const-CjTyAhOC.js';
import { D as DataListActions } from './DataListActions-BbpSgSoY.js';

var styles = {"menu":"jHcHGQ-HDbk-"};

// This component is meant to capture the props of the DataList.ItemActions
function DataListItemActions(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_) {
    return null;
}
const variants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
};
function InternalDataListItemActions({ actions, }) {
    return (React.createElement(motion.div, { variants: variants, initial: "hidden", animate: "visible", exit: "hidden", transition: {
            duration: TRANSITION_DURATION_IN_SECONDS,
            delay: TRANSITION_DELAY_IN_SECONDS,
        }, className: styles.menu, onContextMenu: handleContextMenu },
        React.createElement(DataListActions, null, actions)));
}
function handleContextMenu(event) {
    event.stopPropagation();
}

export { DataListItemActions as D, InternalDataListItemActions as I };
